/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Full_SalaryInputs */

const en_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full DACH salary data`)
};

const de_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige DACH-Gehaltsdaten`)
};

const fr_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données salariales DACH complètes`)
};

const es_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos salariales DACH completos`)
};

const it_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati salariali completi DACH`)
};

const nl_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige DACH-salarisgegevens`)
};

const pl_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełne dane dotyczące wynagrodzenia w DACH`)
};

const fi_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydelliset DACH-palkkatiedot`)
};

const da_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulde DACH-løndata`)
};

const sv_pricing_feature_full_salary = /** @type {(inputs: Pricing_Feature_Full_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig DACH-lönedata`)
};

/**
* | output |
* | --- |
* | "Full DACH salary data" |
*
* @param {Pricing_Feature_Full_SalaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_full_salary = /** @type {((inputs?: Pricing_Feature_Full_SalaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Full_SalaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_full_salary(inputs)
	if (locale === "fr") return fr_pricing_feature_full_salary(inputs)
	if (locale === "es") return es_pricing_feature_full_salary(inputs)
	if (locale === "it") return it_pricing_feature_full_salary(inputs)
	if (locale === "nl") return nl_pricing_feature_full_salary(inputs)
	if (locale === "pl") return pl_pricing_feature_full_salary(inputs)
	if (locale === "fi") return fi_pricing_feature_full_salary(inputs)
	if (locale === "da") return da_pricing_feature_full_salary(inputs)
	if (locale === "sv") return sv_pricing_feature_full_salary(inputs)
	return en_pricing_feature_full_salary(inputs)
});